__turbopack_context__.v({
  "className": "open_sans_66b014a6-module__Uzvqca__className",
  "variable": "open_sans_66b014a6-module__Uzvqca__variable",
});
